
import { defineComponent, ref } from "vue";
import OrderResult from "@/components/common/OrderResult.vue";

export default defineComponent({
  props: {
    res: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const r = ref(props.res);
    return { r };
  },
  components: {
    OrderResult,
  },
});
